const servicesData = [
    {
        id:"1",
        image:require("../../assets/services/Local-Moves.jpg"),
        title:"Local Moves",
        description:"We handle short-distance moves within the same city or a 50-mile radius, ensuring a smooth and hassle-free experience."
    },
    {
        id:"2",
        image:require("../../assets/services/Commercial-Moves.jpg"),
        title:"Commercial Moves",
        description:"Minimize business downtime with our efficient office relocation services. We specialize in handling challenging office moves, including overnight transitions for seamless operations."
    },
    {
        id:"3",
        image:require("../../assets/services/Packing & Unpacking Services.jpg"),
        title:"Packing & Unpacking Services",
        description:"Our expert team provides secure and organized packing to ensure your belongings are safe during transit. We also offer unpacking services to help you settle into your new space quickly."
    },
    {
        id:"4",
        image:require("../../assets/services/Furniture Assembly & Disassembly.jpg"),
        title:"Furniture Assembly & Disassembly",
        description:"We take care of disassembling and reassembling your furniture to ensure a smooth and damage-free move."
    },
    {
        id:"5",
        image:require("../../assets/services/Storage Solutions.jpg"),
        title:"Storage Solutions",
        description:"Need a safe place to store your belongings? We offer secure, short-term and long-term storage solutions to meet your needs."
    },
    {
        id:"6",
        image:require("../../assets/services/Specialty Item Moving.jpg"),
        title:"Specialty Item Moving",
        description:"From pianos and antiques to delicate artwork, our specialized team ensures the safe transport of your valuable and fragile items."
    },
]

export default servicesData;